/**
 * KeepSpatial Configuration Module
 * Reads configuration from script tag attributes or global config
 */

/** @type {string} */
let globalApiKey = '';

/** @type {string} */
/* global __SPATIAL_API_BASE__ */
let apiBase = typeof __SPATIAL_API_BASE__ !== 'undefined'
  ? __SPATIAL_API_BASE__
  : 'https://app.keep.lynkware.com/api/spatial/public';

/**
 * Initialize configuration from script tag or global config
 * Supports both static script tags and dynamic loading
 */
export function initConfig() {
  // Option 1: Check for global config (for dynamic loading)
  if (window.KeepSpatialConfig) {
    if (window.KeepSpatialConfig.apiKey) {
      globalApiKey = window.KeepSpatialConfig.apiKey;
    }
    if (window.KeepSpatialConfig.apiBase) {
      apiBase = window.KeepSpatialConfig.apiBase;
    }
    return;
  }

  // Option 2: Try currentScript (works for static script tags)
  let scriptTag = document.currentScript;

  // Option 3: Find script by src (fallback for dynamic loading)
  if (!scriptTag) {
    scriptTag = document.querySelector('script[src*="spatial.js"][data-api-key]');
  }

  if (scriptTag) {
    // Read API key from data attribute
    const apiKey = scriptTag.getAttribute('data-api-key');
    if (apiKey) {
      globalApiKey = apiKey;
    }

    // Allow custom API base URL (for testing/staging)
    const customBase = scriptTag.getAttribute('data-api-base');
    if (customBase) {
      apiBase = customBase;
    }
  }
}

/**
 * Get the global API key
 * @returns {string}
 */
export function getApiKey() {
  return globalApiKey;
}

/**
 * Get the API base URL
 * @returns {string}
 */
export function getApiBase() {
  return apiBase;
}

/**
 * Script version
 */
export const VERSION = '1.0.0';
